<template>
  <div>
    <div class="popup-header">
      <!--   <div class="corner-badge">
        <div class="corner"></div>
        <span class="label">NIEUW</span>
      </div> -->
      <h1>Stickers & borden</h1>
      <p class="sub-title">Kant-en-klaar, snel bezorgd.</p>
    </div>
    <div class="dialog-content">
      <div class="products-container">
        <div class="overlay"></div>
        <button
          class="product pointer"
          v-for="product in products"
          :key="product.id"
          @click="gotoProduct(product)"
          :aria-label="product.name"
          :style="{
            backgroundImage: setImgUrl(product)
          }"
        ></button>
      </div>
      <!--  <p class="text pointer" @click="gotoPrintStore">Made by Rijnja</p> -->
      <div class="btn-holder">
        <button class="link-button" @click="gotoPrintStore">
          Bekijk ons volledige aanbod
        </button>
      </div>
      <footer>
        <div class="select-holder">
          <select-box
            @action="setStopShowing"
            :selected="stopShowing"
          ></select-box>
          <span class="pointer" @click="setStopShowing"
            >Deze melding niet meer tonen</span
          >
        </div>
        <button class="pill-button secondary close" @click="close">
          sluiten
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  props: ['products'],
  data() {
    return {
      stopShowing: false
      //      products: []
    }
  },
  computed: {
    printStoreId() {
      return this.rootStore.theme.printStore.id
    }
  },
  methods: {
    setImgUrl(product) {
      const printStoreId = product.printStoreId

      // Get random preview image if there are variants
      const image =
        product.hasVariants && product.previews.length > 0
          ? product.previews[
              Math.floor(Math.random() * product.previews.length)
            ].uuid
          : product.previewImage

      return image
        ? `url(/media/print-store/${printStoreId}/preview/${image}/150)`
        : ''
    },
    gotoProduct(product) {
      this.$router.push({
        name: 'printStoreProduct',
        params: {
          categoryId: product.collections[0].categoryId,
          collectionId: product.collections[0].id,
          productId: product.id
        }
      })

      this.$emit('close')
    },
    gotoPrintStore() {
      this.$router.push({
        name: 'printStore'
      })

      this.$emit('close')
    },
    close() {
      let msg
      if (this.stopShowing) {
        msg = 'Close popup & never show'
        this.rootStore.setPreference('showPrintStorePopUp', false)
      } else {
        msg = 'Close popup'
        this.rootStore.setPreference('showPrintStorePopUp', true)
      }

      this.$emit('close')
    },
    setStopShowing() {
      if (this.stopShowing) {
        this.stopShowing = false
      } else {
        this.stopShowing = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 21px;
  font-weight: 500;
  margin-bottom: 7px;
  color: var(--sub-color);
}

.popup-header {
  padding: 25px 25px 0;
}

.sub-title,
.text {
  color: var(--sub-color);
  font-weight: 500;
}

.corner-badge {
  position: absolute;
  right: 0;
  top: 0;
  width: 72px;
  height: 72px;
  overflow: hidden;
  border-top-right-radius: 10px;

  .corner {
    width: 0;
    height: 0;
    border-left: 36px solid transparent;
    border-right: 36px solid #ea0029;
    border-bottom: 36px solid transparent;
    border-top: 36px solid #ea0029;
  }

  span {
    font-size: 13px;
    color: white;
    font-weight: 500;
    transform: rotate(45deg);
    transform-origin: center;
    position: absolute;
    left: 23px;
    top: 19px;
  }
}

.products-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  min-height: 250px;
  position: relative;
}

.product {
  width: 100px;
  height: 100px;
  margin-bottom: 25px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.btn-holder {
  text-align: center;
  padding-top: 10px;
}

.link-button {
  margin-top: 0;
}

footer {
  padding-top: 25px;
  display: flex;
  justify-content: space-between;
}

.select-holder {
  padding-top: 5px;
  text-transform: uppercase;
  font-weight: 500;
  color: var(--sub-color);
  font-size: 11px;
}

.close {
  margin-right: -10px;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background: white;
  pointer-events: none;
  animation: fade 1s 1 forwards 0.4s;
}

@keyframes fade {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
